<template>
	<Component
		:is="as"
		class="relative bg-fill-primary outline outline-1 -outline-offset-1 outline-separator-primary"
		:class="{ 'shadow shadow-gray/2': !flat }"
	>
		<slot />
	</Component>
</template>
<script setup lang="ts">
import type { Component } from 'vue'

withDefaults(
	defineProps<{
		as?: 'div' | 'button' | 'RouterLink' | 'a' | Component
		flat?: boolean
	}>(),
	{
		as: 'div'
	}
)
</script>
